<section class="grid">
  @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_ALL_DB)) {
    <ms-stat-card-widget [value]="widgets.numberOfDb" [progressPercent]="100"
                         [title]="'Nombre total de db'"></ms-stat-card-widget>
  }
  @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_CLUSTER_1)) {
    <ms-stat-card-widget [value]="widgets.cluster_1" [progressPercent]="(widgets.cluster_1 / widgets.numberOfDb * 100)"
                         [title]="'Cluster 1'"></ms-stat-card-widget>
  }
  @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_CLUSTER_2)) {
    <ms-stat-card-widget [value]="widgets.cluster_2" [progressPercent]="(widgets.cluster_2 / widgets.numberOfDb * 100)"
                         [title]="'Cluster 2'"></ms-stat-card-widget>
  }
  @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_DUPLICATE)) {
    <ms-stat-card-widget [value]="widgets.duplicate" [progressPercent]="(widgets.duplicate / widgets.numberOfDb * 100)"
                         [title]="'Doublons potentiels'"></ms-stat-card-widget>
  }
</section>
@if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_NEW_USER) || accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_FULL_STEP)) {
  <section class="grid">
    @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_NEW_USER)) {
      <ms-stat-card-widget [value]="widgets.newUserLast24h"
                           [progressPercent]="(widgets.newUserLast24h / widgets.steps.step_6 * 100)"
                           [title]="'Nouveaux utilisateurs depuis 24h'"></ms-stat-card-widget>
    }

    @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_FULL_STEP)) {
      <ms-stat-card-widget
        [value]="(widgets.steps.step_1 + widgets.steps.step_2 + widgets.steps.step_3 + widgets.steps.step_4 + widgets.steps.step_5 + widgets.steps.step_6)"
        [progressPercent]="100"
        [title]="'Nombre d\'utilisateurs'"></ms-stat-card-widget>
    }

    @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_FULL_STEP)) {
      <ms-stat-card-widget [value]="widgets.steps.step_6"
                           [progressPercent]="((widgets.steps.step_6 / (widgets.steps.step_1 + widgets.steps.step_2 + widgets.steps.step_3 + widgets.steps.step_4 + widgets.steps.step_5 + widgets.steps.step_6)) * 100)"
                           [title]="'Usr totalement configurés'"></ms-stat-card-widget>
    }

  </section>
}

<section class="columns">
  <ms-alert-widget [title]="'Alerts & statuts'" [alerts]="alerts"></ms-alert-widget>
  @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DASHBOARD, ModuleTypeEnum.DASHBOARD_WIDGET, SubModuleTypeEnum.DASHBOARD_WIDGET_USER_WALLONIA)) {
    <ms-pie-chart-widget title="Répartition géographique"
                      [labels]="['Wallonie', 'Flandre', 'Bruxelles']"
                      [data]="[widgets.districtRepartition?.wal, widgets.districtRepartition?.fla, widgets.districtRepartition?.bxl]"
                      [colors]="['#b91010', '#c5c222', '#0e66e9']"
                      type="pie"></ms-pie-chart-widget>
  }
</section>

<ms-activity-indicator-with-messages [fullWidth]="true" [isLoading]="isLoading" [overlay]="true" [messages]="messages"></ms-activity-indicator-with-messages>
